export default {
  emailFrom: {
    value: '',
    maxlength: '70',
    required: false,
    state: null
  },
  emailHost: {
    value: '',
    maxlength: '70',
    required: false,
    state: null
  },
  safeConnection: {
    value: null,
    options: [
      { value: 1, text: 'NENHUMA' },
      { value: 2, text: 'SSL' },
      { value: 3, text: 'STARTTLS' }
    ],
    required: true,
    state: null
  }
}



// WEBPACK FOOTER //
// ./src/views/private/configurations/email/components/search/search-form.js